import DodoneShowGenericWrapper from 'app/dodones/generic/show/Wrapper'
import Metronome from 'shared/components/metronome/Index'
import DodoneGenericShowContext from 'app/dodones/generic/show/Context'
import DodoneContext from 'app/dodones/Context'

const ExerciseItem = ({
  index,
  tickCount,
  exercise,
  exerciseIndex,
  setExerciseIndex
}) => {
  const resetExerciseItem = useCallback(() => {
    setExerciseIndex(index)
  })

  return (
    <div
      className={clsx('px-d py-h frow', {
        'gray-transparent-box': index > exerciseIndex,
        'green-transparent-box': index < exerciseIndex,
        'blue-transparent-box': index == exerciseIndex
      })}
    >
      <div className="flex-1">{exercise.signature}</div>
      {index == exerciseIndex && (
        <div>
          {tickCount}/{exercise.count}
        </div>
      )}
      {index != exerciseIndex && (
        <i className="ph ph-play" onClick={resetExerciseItem}></i>
      )}
    </div>
  )
}

export default () => {
  const { dodone } = useContext(DodoneContext)
  const exercises = dodone.settings.exercises

  const [bpm, setBpm] = useState(110)
  const [stop, setStop] = useState(0)

  const [exerciseIndex, setExerciseIndex] = useState(0)
  const [tickCount, setTickCount] = useState(0)

  const onTick = useCallback(() => {
    setTickCount((currentTickCount) => {
      const newTickCount = currentTickCount + 1
      if (newTickCount < exercises[exerciseIndex].count) return newTickCount

      setExerciseIndex((currentExerciseIndex) => {
        return currentExerciseIndex + 1
      })

      setStop((currentStop) => {
        return currentStop + 1
      })

      return 0
    })
  })

  return (
    <DodoneGenericShowContext.Provider
      value={{ showCommentFieldTrigger: false }}
    >
      <DodoneShowGenericWrapper chronometerParameters={{ hide: true }}>
        <Metronome
          bpm={bpm * (exercises[exerciseIndex]?.multiplier || 1)}
          setBpm={setBpm}
          onTick={onTick}
          stop={stop}
          exerciseIndex={exerciseIndex}
          setExerciseIndex={setExerciseIndex}
        />

        {Object.entries(exercises).map(([index, exercise]) => {
          return (
            <ExerciseItem
              key={index}
              index={index}
              exercise={exercise}
              exerciseIndex={exerciseIndex}
              setExerciseIndex={setExerciseIndex}
              tickCount={tickCount}
            />
          )
        })}
      </DodoneShowGenericWrapper>
    </DodoneGenericShowContext.Provider>
  )
}
